import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, ValueControlBtn } from 'veloe-ds';

import { salvaValorRecarga } from '../../actions/pedidoActions';

import './recargaAutomatica.scss';
import { APP_PAGES } from '../../routes';
import { veloeGraphQlApi } from '../../api/graphql/graphQLAPI';
import recargaFCG from '../../mutations/recarga';
import ScriptTag from 'react-script-tag';
import { withSnackbar } from 'notistack';
import { modalInformativo } from '../../Components/Modais';
import {
  eventTrackBasic,
  eventTrackRoute,
  eventTrackEcommerce,
} from '../../utils/pushDataLayer.js';

/**
 * Exibe as opções de recarga.js de crédito para o cliente
 *
 * A lista de valores para recarga.js é composta por:
 *
 *  id (inteiro)
 *  valor
 *
 * A váriavel botaoContinuar indica se o botão será apresentado na tela (true) ou se o click no valor irá para o proximo passo (false - atual)
 * Após a escolha, salva o id e o valor do crédito no dicionário
 * */
const RecargaAutomatica = ({
  activeLoader,
  inactiveLoader,
  history,
  pedido,
  salvaValorRecarga,
}) => {
  const { valorRecarga: pedidoValorRecarga } = pedido;

  const [botaoContinuar, setBotaoContinuar] = useState(true);
  const [valorRecarga, setValorRecarga] = useState(pedidoValorRecarga);
  const [textoTermos, setTextoTermos] = useState('');
  const [openModalInformativo, setOpenModalInformativo] = useState(false);
  const [subProductId] = useState(
    JSON.parse(localStorage.getItem('proposta')).subProdutoId,
  );

  useEffect(() => {
    eventTrackRoute('recarga-automatica');
  }, []);

  useEffect(() => {
    if (valorRecarga > 0) {
      selecionaValorRecarga(valorRecarga);
      //eventTrackEcommerce(pedido, valorRecarga, ['detail', 'recarga']);
      eventTrackBasic('clique:opcao', `recarga-valor:${valorRecarga}`);
    }
    const proposta = JSON.parse(localStorage.getItem('proposta'));
    if (!proposta) {
      history.push(APP_PAGES.CADASTRO);
    }
  }, [history, selecionaValorRecarga, valorRecarga]);

  const chamaFuncRand = async () => {
    const reCaptcha = await window.grecaptcha.execute(
      process.env.REACT_APP_KEY_RECAPTCHA,
      {
        action: 'homepage',
      },
    );
    activeLoader();

    const proposta = JSON.parse(localStorage.getItem('proposta'));
    veloeGraphQlApi(recargaFCG, {
      idProposta: proposta.dados.id,
      captchaResponse: reCaptcha,
      valorRecargaPrePago: valorRecarga,
    })
      .then((data) => {
        const { dados, validatorResponse } = data['recargaFCG'];
        if (dados) {
          //eventTrackEcommerce(pedido, valorRecarga, ['add', 'recarga']);
          eventTrackBasic('callback:recarga', `recarga-valor:${valorRecarga}`);
          inactiveLoader();
          history.push(APP_PAGES.REVISE_COMPRA);
        } else {
          const { errors } = validatorResponse;
          inactiveLoader();
          return errors.map((error) => {
            setTextoTermos(error.message);
            setOpenModalInformativo(true);
          });
        }
      })
      .catch((err) => {
        inactiveLoader();
        setTextoTermos(err.message);
        setOpenModalInformativo(true);
      });
  };

  const selecionaValorRecarga = useCallback(
    (event) => {
      salvaValorRecarga(event);
      setValorRecarga(event);
      setBotaoContinuar(false);
    },
    [salvaValorRecarga],
  );
  return (
    <div className="containerComponent">
      <div className="containerText">
        <div className="containerLabel">
          <label className="areaTexto">Escolha o valor da sua recarga</label>
          <br />
          {subProductId === '001' ? (
            <span>
              Com o plano sem mensalidades, você fica livre das cobranças
              mensais e ainda tem controle total sobre quando e quanto carregar,
              pagando apenas uma tarifa sobre o valor escolhido.
            </span>
          ) : (
            <span className="descricao">
              Você escolhe o valor da primeira recarga e as próximas são feitas
              automaticamente quando seu saldo estiver acabando. Lembrando que
              você pode mudar o valor da recarga quando desejar.
            </span>
          )}
        </div>
      </div>
      <div className="containerArea">
        {valorRecarga === 50 && subProductId === '001' && (
          <div className="balloon" style={{ transform: 'translate(20%, 20%)' }}>
            <b>Tarifa:</b> R$9,90 (20%) <br /> <b>Saldo final:</b> R$40,10
          </div>
        )}
        {valorRecarga === 75 && subProductId === '001' && (
          <div
            className="balloon"
            style={{ transform: 'translate(120%, 20%)' }}
          >
            <b>Tarifa:</b> R$12,90 (17%) <br /> <b>Saldo final:</b> R$62,10
          </div>
        )}
        {valorRecarga === 100 && subProductId === '001' && (
          <div
            className="balloon"
            style={{ transform: 'translate(220%, 20%)' }}
          >
            <b>Tarifa:</b> R$15,90 (16%) <br /> <b>Saldo final:</b> R$84,10
          </div>
        )}
        {valorRecarga === 150 && subProductId === '001' && (
          <div
            className="balloon"
            style={{ transform: 'translate(320%, 20%)' }}
          >
            <b>Tarifa:</b> R$21,90 (15%) <br /> <b>Saldo final:</b> R$128,10
          </div>
        )}
        {valorRecarga === 200 && subProductId === '001' && (
          <div
            className="balloon"
            style={{ transform: 'translate(20%, 240%)' }}
          >
            <b>Tarifa:</b> R$30,90 (15%) <br /> <b>Saldo final:</b> R$169,10
          </div>
        )}
        {valorRecarga === 250 && subProductId === '001' && (
          <div
            className="balloon"
            style={{ transform: 'translate(120%, 240%)' }}
          >
            <b>Tarifa:</b> R$32,90 (13%) <br /> <b>Saldo final:</b> R$217,10
          </div>
        )}
        {valorRecarga === 350 && subProductId === '001' && (
          <div
            className="balloon"
            style={{ transform: 'translate(220%, 240%)' }}
          >
            <b>Tarifa:</b> R$34,90 (10%) <br /> <b>Saldo final:</b> R$315,10
          </div>
        )}
        {valorRecarga === 500 && subProductId === '001' && (
          <div
            className="balloon"
            style={{ transform: 'translate(320%, 240%)' }}
          >
            <b>Tarifa:</b> R$44,90 (9%) <br /> <b>Saldo final:</b> R$455,10
          </div>
        )}
        <div className="containerRecarga">
          <ValueControlBtn
            {...{
              values: [50, 75, 100, 150, 200, 250, 350, 500],
              prefix: 'R$ ',
              onChange: selecionaValorRecarga,
              onBg: 'light',
              value: setValorRecarga,
              id: 'valor-recarga.js',
            }}
          />
          <span className="descricao-mobile">
            Você escolhe o valor da primeira recarga e as próximas são feitas
            automaticamente quando seu saldo estiver acabando. Lembrando que
            você pode mudar o valor da recarga quando desejar.
          </span>
          <div className="stack-button-container"></div>
          <Button
            className="stack-button-full"
            {...{
              color: 'primary',
              disabled: botaoContinuar,
              label: 'Continuar para revisão',
              id: 'btn-continuar',
            }}
            onClick={chamaFuncRand}
          />
        </div>
      </div>
      {openModalInformativo &&
        modalInformativo(
          true,
          () => {
            setOpenModalInformativo(false);
          },
          'Ops!',
          textoTermos,
        )}
      <ScriptTag
        type="text/javascript"
        src={`https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`}
      />
    </div>
  );
};

const mapStateToProps = ({ pedido }) => {
  return { pedido };
};

const mapDispatchToProps = (dispatch) => {
  return {
    salvaValorRecarga: (valor) => dispatch(salvaValorRecarga(valor)),
    activeLoader: () => dispatch({ type: 'loader_active' }),
    inactiveLoader: () => dispatch({ type: 'loader_inactive' }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(RecargaAutomatica));
